import React from 'react'
import { useParams } from 'react-router-dom';
import Icon from "./icon.js"

const LoginPreProd = ({client}) => {

  const { org } = useParams()
  const preProdLoginURL = client.preProdLoginURL ? client.preProdLoginURL : null
  const shouldShowLogin = org && preProdLoginURL

  return (
    shouldShowLogin ? (
      <div className='login__preprod-login'>
        <h4>Pre-production environment</h4>
        <button role="button" className="-u-btn login__button -u-btn--block" 
          onClick={() => {
          window.location.href = preProdLoginURL
        }}>
          <span className="-u-btn__content">
            <Icon className='hover-icon icon' />
            Login
          </span>
        </button>
      </div>
    ) : null
  )

}

export default LoginPreProd